'use client';

import { c as _c } from "react/compiler-runtime";
import { ROUTES } from '@/constants';
import { useCheckWelloApp } from '@/hooks/useCheckWelloApp';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';
import { openResponsiveDialog } from '@/stores/ResponsiveDialogStore';
import { createAppOnlyDialog } from '../_components/AppOnlyDialog';

//* useBenefitGate는 복귀 경로가 pathname 고정이라 신청 경로·?tab=my 복귀용으로 같은 순서(앱→로그인)를 둔다
export const useGiftTrialGate = () => {
  const $ = _c(5);
  const router = useCustomRouter();
  const isLogin = useAuthStore(_temp);
  const {
    isChecking,
    isWelloApp
  } = useCheckWelloApp();
  let t0;
  if ($[0] !== isChecking || $[1] !== isLogin || $[2] !== isWelloApp || $[3] !== router) {
    t0 = (redirect, onPass) => {
      if (isChecking || isLogin === undefined) {
        return;
      }
      if (!isWelloApp) {
        openResponsiveDialog(createAppOnlyDialog());
        return;
      }
      if (!isLogin) {
        router.push(ROUTES.LOGIN.withSearchParams({
          searchParams: {
            redirect
          }
        }));
        return;
      }
      onPass();
    };
    $[0] = isChecking;
    $[1] = isLogin;
    $[2] = isWelloApp;
    $[3] = router;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};
function _temp(state) {
  return state.isLogin;
}